export { default } from './useMetaTags';
